import moment from 'moment'
import localization from 'moment/locale/th'
import { toBuddhistYear } from './buddhist-year'
import _ from 'lodash'
import React from 'react'
import { toGregorianYear } from "./gregorian-year";

export function convertDate(tmpDate, format) {
    // let date = moment(tmpDate).locale('th', localization).format(format ? format : 'DD MMMM YYYY')
    if (!tmpDate) {
        return '-'
    }
    let date = toBuddhistYear(moment(tmpDate).locale('th', localization), format ? format : 'DD MMMM YYYY')
    return date
}

export function convertDateToDB(tmpDate, format) {
    // let date = moment(tmpDate).locale('th', localization).format(format ? format : 'DD MMMM YYYY')
    let date = toGregorianYear(moment(tmpDate), format ? format : 'YYYY-MM-DD')
    return date
}
//ใช้สำหรับที่ต้องการแสดงค่าวันที่ ที่ไม่ต้องการให้มี +7 ชั่วโมง

export function convertDateEng(tmpDate, format) {
    let date = moment(tmpDate)
        .locale('en', localization)
        .format(format ? format : 'YYYY-MM-DD')
    //let date = tmpDate.format(format ? format : 'YYYY-MM-DD')
    return date
}

export function isEmpty(obj) {
    for (var x in obj) {
        return false
    }
    return true
}

export function thousands_separators(number = 0, digit = 2) {
    let num_parts

    number = (Math.round(number * 100) / 100).toFixed(digit)
    num_parts = number.toString().split('.')
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    return num_parts.join('.')
}

export function time_from_now(time_string) {
    return moment(time_string).fromNow()
}

export function splitCampusName(campusNameTh) {
    let campusNameOnly = campusNameTh ? campusNameTh.split('วิทยาเขต') : null
    return campusNameOnly
}

export function convertDateFin(tmpDate) {
    let dateFin = new Date(tmpDate)
    let date = moment(dateFin)
        .locale('th', localization)
    return date
}

export function CompareArray(a, b) {
    return a.length === b.length && a.every((v, i) => v === b[i]);
}

export const getLastFiveYearArray = (isBudish = true) => {
    let currentYear = new Date().getFullYear()
    currentYear = isBudish ? currentYear + 543 : currentYear
    return [
        { year: currentYear, isActive: true },
        { year: currentYear - 1, isActive: false },
        { year: currentYear - 2, isActive: false },
        { year: currentYear - 3, isActive: false },
        { year: currentYear - 4, isActive: false },
    ]
}

export const getLastTenYearArray = (isBudish = true, defaultYear = null) => {
    let currentYear = new Date().getFullYear()
    currentYear = isBudish ? currentYear + 543 : currentYear
    return [
        { year: currentYear, isActive: true },
        { year: currentYear - 1, isActive: false },
        { year: currentYear - 2, isActive: false },
        { year: currentYear - 3, isActive: false },
        { year: currentYear - 4, isActive: false },
        { year: currentYear - 5, isActive: false },
        { year: currentYear - 6, isActive: false },
        { year: currentYear - 7, isActive: false },
        { year: currentYear - 8, isActive: false },
        { year: currentYear - 9, isActive: false },
    ]
}

export const getNextTenYearArray = (isBudish = true, defaultYear = null) => {
    let currentYear = new Date().getFullYear()
    currentYear = isBudish ? currentYear + 543 : currentYear
    return [
        { year: currentYear, isActive: true },
        { year: currentYear + 1, isActive: false },
        { year: currentYear + 2, isActive: false },
        { year: currentYear + 3, isActive: false },
        { year: currentYear + 4, isActive: false },
        { year: currentYear + 5, isActive: false },
        { year: currentYear + 6, isActive: false },
        { year: currentYear + 7, isActive: false },
        { year: currentYear + 8, isActive: false },
        { year: currentYear + 9, isActive: false },
    ]
}

export const semesterArray = () => {
    return [
        { labelTh: "ภาคต้น", labelEn: "First semester", value: "1", isActive: true },
        { labelTh: "ภาคปลาย", labelEn: "Second semester", value: "2", isActive: false },
        { labelTh: "ภาคฤดูร้อน", labelEn: "Summer semester", value: "0", isActive: false },
    ]
}

export const semesterArrayByValue = (semesterValue) => {
    return semesterArray().find(item => item.value == semesterValue) || {}
}
export const uuid = () => {
    const url = URL.createObjectURL(new Blob())
    const [id] = url.toString().split('/').reverse()
    URL.revokeObjectURL(url)
    return id
}

export const showAsCurrency = (input, defaultZero = false, digit = 2) => {
    if (input === null && defaultZero) {
        let num = 0
        return num.toLocaleString('th-Th', { minimumFractionDigits: digit })
    }

    return parseFloat(input)
        .toLocaleString('th-Th', { minimumFractionDigits: digit })
}

export const setTimeoutPromise = (time) => new Promise((resolve, reject) => setTimeout(resolve, time))

export const getRandomInt = (max, min = 0) => {
    return min + Math.floor(Math.random() * max - min);
}

export const sumArray = (array) => {
    let total = 0;
    for (let value of array) {
        total += parseFloat(value);
    }
    return total
}

export const allocationSemesterType = () => {
    return [
        { id: 1, name: "ทุกภาคเรียน" },
        { id: 2, name: "ภาคเรียนปกติ" },
        { id: 3, name: "ภาคฤดูร้อน" }
    ]
}



export const campusArray = (targetValue = null) => {
    const campusArr = [
        { campusCode: 'B', campusName: 'บางเขน', campusNameEn: 'Bangkhen' },
        { campusCode: 'C', campusName: 'สกลนคร', campusNameEn: 'Sakon Nakhon Province' },
        { campusCode: 'I', campusName: 'สถาบันสมทบ', campusNameEn: 'Affiliated Institute' },
        { campusCode: 'K', campusName: 'กำแพงแสน', campusNameEn: 'Kamphaeng Saen' },
        { campusCode: 'P', campusName: 'สุพรรณบุรี', campusNameEn: 'Suphan Buri' },
        { campusCode: 'S', campusName: 'ศรีราชา', campusNameEn: 'Sri Racha' },
    ]

    if (targetValue) {
        return campusArr.find(item => item.campusCode == targetValue)
    }

    return campusArr
}

export const compareDates = (d1, d2) => {
    let date1 = new Date(d1).getTime();
    let date2 = new Date(d2).getTime();

    if (date1 < date2) {
        return 0
    } else if (date1 > date2) {
        return 1
    } else {
        return -1
    }
}

export const getExaminerPosition = () => {
    return [
        { positionId: 1, name: "กรรมการหัวหน้าห้อง" },
        { positionId: 2, name: "รองกรรมการหัวหน้าห้อง" },
        { positionId: 3, name: "กรรมการ" }
    ]
}

export const studentType = [
    {
        studentTypeCode: "17001",
        studentTypeNameTh: "ภาคปกติ",
        studentTypeNameEn: "Regular student"
    },
    {
        studentTypeCode: "17002",
        studentTypeNameTh: "ภาคพิเศษ",
        studentTypeNameEn: "Special student"
    },
    {
        studentTypeCode: "17003",
        studentTypeNameTh: "นานาชาติ ภาคปกติ",
        studentTypeNameEn: "Regular international student"
    },
    {
        studentTypeCode: "17004",
        studentTypeNameTh: "นานาชาติ ภาคพิเศษ",
        studentTypeNameEn: "Special international student"
    }
]
export function renderYearByOffset(minYearOffset = -8, maxYearOffset = 1, locale = 'th-TH') {
    let currentYear = new Date().getFullYear() + 543
    let html = []

    const minYear = currentYear + minYearOffset
    const maxYear = currentYear + maxYearOffset

    for (let year = maxYear; year >= minYear; year--) {
        html.push(year)
    }
    return (
        <>
            {html.map((y, index) => {
                return (
                    <option value={y} field="year" key={index}>
                        {locale == 'th-TH' ? y : +y - 543}
                    </option>
                )
            })}
        </>
    )
}

export function getYearByOffsetArray(minYearOffset = -8, maxYearOffset = 1) {
    let currentYear = new Date().getFullYear() + 543
    let result = []

    const minYear = currentYear + minYearOffset
    const maxYear = currentYear + maxYearOffset

    for (let year = maxYear; year >= minYear; year--) {
        result.push({ year })
    }
    return result
}
